import { put, takeLatest } from 'redux-saga/effects'
import { APP_SETUP } from './constants';
import { getCurrentUser } from '../Login/actions';

function* appSetupTask() {
  yield put(getCurrentUser())
}

function* appSetupWatcher() {
  yield takeLatest(APP_SETUP, appSetupTask);
}

export default [
  appSetupWatcher,
];
